import { ComponentStyleConfig } from '@chakra-ui/react';

export const List: ComponentStyleConfig = {
    baseStyle: {
        content: {
            borderRadius: 0
        }
    }
};
